import React, { useEffect, useState } from 'react';
import API_BASE_URL from './config';

function formatDate(dateStr) {
  if (!dateStr) return '';
  if (typeof dateStr === 'string' && dateStr.includes('GMT')) {
    const d = new Date(dateStr);
    if (!isNaN(d)) return d.toISOString().split('T')[0];
  }
  if (typeof dateStr === 'string' && dateStr.includes('T')) return dateStr.split('T')[0];
  return dateStr;
}

function translateAction(action) {
  switch (action) {
    case 'add_car': return 'إضافة سيارة';
    case 'add_movement': return 'إضافة حركة';
    case 'delete_car': return 'حذف سيارة';
    case 'delete_movement': return 'حذف حركة';
    default: return action;
  }
}

// دالة لتنسيق التفاصيل بحيث يتم تنسيق التاريخ داخل التفاصيل
function formatDetails(details) {
  if (!details) return '';
  return details.replace(/Date: ([^,]+)/, function(match, dateStr) {
    var d = new Date(dateStr);
    if (!isNaN(d)) {
      return 'Date: ' + d.toISOString().split('T')[0];
    }
    return match;
  });
}

function AuditLog() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_BASE_URL}/audit-log`)
      .then(res => res.json())
      .then(data => {
        setLogs(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="w-full max-w-7xl mx-auto p-6 text-center">
      <div className="card shadow-modern">
        <div className="text-6xl mb-4 animate-pulse">📊</div>
        <h3 className="text-xl font-semibold text-gray-700">جاري تحميل سجل الأحداث...</h3>
        <div className="mt-4 w-48 h-2 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-full mx-auto animate-pulse"></div>
      </div>
    </div>
  );

  return (
    <div dir="rtl" className="w-full max-w-7xl mx-auto p-6" style={{ direction: 'rtl', textAlign: 'right' }}>
      <div className="mb-8 animate-slideInDown">
        <h2 className="text-3xl font-bold bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent mb-2">
          سجل الأحداث
        </h2>
        <p className="text-gray-600">تتبع جميع العمليات والتعديلات في النظام</p>
      </div>

      <div className="card shadow-modern animate-slideInDown" style={{animationDelay: '0.1s'}}>
        <div className="flex items-center justify-between mb-6">
          <h3 className="text-xl font-semibold flex items-center gap-2">
            <span className="w-8 h-8 bg-gradient-to-r from-purple-500 to-pink-500 rounded-lg flex items-center justify-center text-white text-sm">📋</span>
            سجل العمليات ({logs.length})
          </h3>
        </div>
        
        {logs.length === 0 ? (
          <div className="text-center py-12 text-gray-500">
            <div className="text-6xl mb-4 animate-float">📝</div>
            <p className="text-lg">لا توجد أحداث مسجلة بعد</p>
            <p className="text-sm">ستظهر هنا جميع العمليات التي تم تنفيذها في النظام</p>
          </div>
        ) : (
          <div className="overflow-x-auto">
            <table className="table-modern">
              <thead>
                <tr>
                  <th>العملية</th>
                  <th>التفاصيل</th>
                  <th>التاريخ</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log, index) => (
                  <tr key={log.id} style={{animationDelay: `${index * 50}ms`}} className="animate-slideInDown">
                    <td>
                      <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${
                        log.action === 'add_car' || log.action === 'add_movement' 
                          ? 'bg-green-100 text-green-800' 
                          : log.action === 'delete_car' || log.action === 'delete_movement'
                          ? 'bg-red-100 text-red-800'
                          : 'bg-blue-100 text-blue-800'
                      }`}>
                        {log.action === 'add_car' || log.action === 'add_movement' ? '➕' : 
                         log.action === 'delete_car' || log.action === 'delete_movement' ? '🗑️' : '📝'} 
                        {translateAction(log.action)}
                      </span>
                    </td>
                    <td>
                      <div className="max-w-md">
                        <pre className="whitespace-pre-wrap text-sm text-gray-700 font-mono bg-gray-50 p-2 rounded border">
                          {formatDetails(log.details)}
                        </pre>
                      </div>
                    </td>
                    <td>
                      <div className="flex items-center gap-2">
                        <span className="w-2 h-2 bg-indigo-500 rounded-full animate-pulse"></span>
                        <span className="font-medium text-gray-700">{formatDate(log.created_at)}</span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default AuditLog;
